module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lynx/lyn_vis-fc470e23d9a496af956141103008c1ff.jpg";